import store from '../../store/store';
import { resetMember } from './memberSlice';
import { resetGeneral } from '../general/generalSlice';
import { resetAuth } from '../auth/authSlice';
import { resetExchangesState } from '../exchanges/exchangesSlice';

import { resetLegs } from '../legs/legsSlice';
import { resetBalances } from '../balances/balancesSlice';
import { resetJournals } from '../journals/journalsSlice';
import { resetPaymentState } from '../payments/paymentsSlice';
import { resetVerification } from '../verification/verificationSlice';
import { resetBanners } from '../banners/bannersSlice';
import websocket from '../../lib/websocket';
import { logoutUserApi } from '@/api/userApi';
import { resetShortStorage } from '@/state/shortStorage/shortStorageSlice';
import { resetNotificationState } from '@/state/notifications/notificationsSlice';
import { resetLeaderboardState } from '@/state/leaderboard/leaderboardSlice';
import { resetIntelligence } from '@/state/intelligence2/intelligence2Slice';
import syncStoreService from '@/store/syncStore/SyncStoreService';
import { resetHypertracker, resetLeaderboardsFilters } from '@/state/hypertracker/hypertackerSlice';
import { queryClient } from '@/lib/query/queryClient';
import { setSentryUser } from '@/lib/sentry/sentry';

export const logoutMember = async (
    withApi: boolean = true,
    onApiLogoutSuccess?: () => void,
): Promise<void> => {
    try {
        if (withApi) {
            await logoutUserApi();
            document.cookie = `isAuth=false; domain=coinmarketman.com`;
            document.cookie = `loggedEnv=; domain=coinmarketman.com`;
        }
    } catch (error) {
        // silent fail for logout api call;
        console.log(error);
    }
    onApiLogoutSuccess?.();
    localStorage.removeItem('lastBannerViewDate');

    websocket.disconnect();
    syncStoreService.resetSyncStore();
    queryClient.clear();
    setSentryUser(null);
    store.dispatch(resetExchangesState());
    store.dispatch(resetGeneral());
    store.dispatch(resetMember());
    store.dispatch(resetAuth());
    store.dispatch(resetLegs());
    store.dispatch(resetBalances());
    store.dispatch(resetJournals());
    store.dispatch(resetPaymentState());
    store.dispatch(resetVerification());
    store.dispatch(resetBanners());
    store.dispatch(resetShortStorage());
    store.dispatch(resetNotificationState());
    store.dispatch(resetLeaderboardState());
    store.dispatch(resetIntelligence());
    store.dispatch(resetLeaderboardsFilters());
    store.dispatch(resetHypertracker());
};
